import React from "react";
import Button from "../../form/Button";
import logoimg from "../../../assets/images/front/user01.webp";

const AboutCompany = ({ organization }) => {
  if (!organization) return null;

  const { logo, content, businessInfo } = organization;

  const companyName = content?.en?.title || "Unknown Company";
  const companyDescription =
    content?.en?.content || "No company description available.";
  const employeeCount = businessInfo?.employeeCount || "N/A";
  return (
    <div className="">
      <div className=" pb-4">
        <h2 className="text-lg md:text-lg text-black dark:text-gray-100 capitalize font-bold leading-tight mb-3">
          About the company
        </h2>

        <div className="flex items-center justify-between">
          <div className="flex items-center gap-4">
            {/* <div className="w-14 h-14 rounded-md bg-indigo-700 flex items-center justify-center">
              <span className="text-white text-3xl font-bold">p</span>
            </div> */}
            {logo?.url ? (
              <img
                src={logo.url}
                alt={companyName}
                className="w-14 h-14 rounded-md object-contain"
              />
            ) : (
              <div className="w-14 h-14 rounded-md bg-gray-200 flex items-center justify-center">
                <span className="text-gray-500 text-lg font-bold">
                  {companyName.charAt(0)}
                </span>
              </div>
            )}

            <div>
              <div className="text-base font-semibold text-gray-900">
                {companyName}
              </div>
              <div className="text-sm text-gray-500">
                {" "}
                {employeeCount} employees
              </div>
            </div>
          </div>
        </div>

        {/* <div className="mt-4 text-sm text-gray-800 font-medium">
          Hospitals and Health Care • 501–1,000 employees • 1,672 on LinkedIn
        </div> */}

        <div className="mt-2 text-sm text-gray-600 leading-relaxed line-clamp-3">
          {companyDescription}
        </div>
      </div>

      <div className="border-t border-gray-200 text-center pt-4 flex justify-center items-center">
        <Button
          buttonLabel="View More"
          buttonHasLink
          buttonLink={`/company/${organization?.slug}`}
          buttonClasses="bg-white text-palatte hover:bg-transparent hover:text-white border border-white px-3 h-8 rounded-full border-palatte hover:bg-palatte "
          buttonLabelClasses="font-semibold"
        />
      </div>
    </div>
  );
};

export default AboutCompany;
